// A register row's source detail, cropped from the sheet at its tag
// (guide 21.7, back/utils/evidenceCrop). Rows without a page position -
// DWGs, the model - show nothing rather than a guess.
//
//   <EvidenceThumb projectId={projectId} evidence={{ docId, revisionNumber, page, box }} />
import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { url, tokenRef } from "api";

export default function EvidenceThumb({ projectId, evidence, height = 44 }) {
  const [src, setSrc] = useState("");
  const e = evidence || null;
  const key = e ? `${e.docId}|${e.revisionNumber}|${e.page}|${(e.box || []).join(",")}` : "";
  useEffect(() => {
    if (!e || !projectId || !Array.isArray(e.box) || e.box.length !== 4) { setSrc(""); return undefined; }
    let alive = true; let made = "";
    const q = `docId=${encodeURIComponent(e.docId)}&rev=${e.revisionNumber == null ? "" : encodeURIComponent(e.revisionNumber)}&page=${encodeURIComponent(e.page || 1)}&box=${e.box.map(Number).join(",")}`;
    fetch(`${url}/projects/${projectId}/evidence/crop?${q}`, { headers: { Authorization: `Bearer ${localStorage.getItem(tokenRef)}` } })
      .then((r) => (r.ok ? r.blob() : null))
      .then((b) => { if (alive && b) { made = URL.createObjectURL(b); setSrc(made); } })
      .catch(() => {});
    return () => { alive = false; if (made) URL.revokeObjectURL(made); };
  }, [projectId, key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!src) return null;
  return <Image src={src} height={height} alt="Source detail from the sheet" style={{ border: "1px solid #E2E2E2", borderRadius: 3 }} preview={{ mask: "View" }} />;
}
